// extracted by mini-css-extract-plugin
export default {"titleHolder":"CreditRestorationQuizError_titleHolder__259bx","subtitle":"CreditRestorationQuizError_subtitle__5CN4t"};